<template>
    <section class="tipo-denticao-select">
        <label for="denticao-select" class="tipo-denticao-select__label">Paciente apresenta-se na dentição</label>
        <selectTextUI id="denticao-select" :options="getDenticaoSelectItems" :defaultSelected="selectedDenticao"
            @change="onTipoDenticaoChange" />
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import selectTextUI from '@/components/ui/select/selectText.vue';

export default {
    name: 'tipoDenticaoReportSelect',
    components: {
        selectTextUI
    },
    props: {
    },

    data() {
        return {
            selectedDenticao: null
        }
    },

    watch: {
        GET_selectedDenticaoReportNode(newVal) {
            if (this.selectedDenticao != newVal?.id) {
                this.selectedDenticao = newVal?.id ?? null;
            }
        }
    },

    methods: {
        onTipoDenticaoChange(selectedValue) {
            this.selectedDenticao = selectedValue;
            this.$store.dispatch('ACT_reportNodes_setDenticaoNode', {
                nodeId: this.selectedDenticao
            });
        },
    },

    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_selectedDenticaoReportNode',
        ]),

        getDenticaoSelectItems() {
            const tipoDenticaoNodes = this.GET_filteredNodes.filter(node => (node.layout.parent === 'layer_tipoDenticao'));
            return [
                { value: null, label: '[indefinida]' },
                ...tipoDenticaoNodes.map(node => ({ value: node.id, label: node.layout.label.toLowerCase() }))
            ];
        },
    },

    mounted() {
        this.selectedDenticao = this.GET_selectedDenticaoReportNode?.id ?? null;
    }
}
</script>

<style scoped>

.tipo-denticao-select {
    display: flex;
    align-items: baseline;
    gap: var(--spacing-xs);
    font-family: var(--font-family-primary);
    padding: 0;
}

.tipo-denticao-select :deep(.select#denticao-select) {
    padding-top: 2px;
    padding-bottom: 2px;
}

.tipo-denticao-select__label {
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    color: var(--report-text-color);
    margin-top: -3px;
}

</style>